module.exports = __webpack_public_path__ + "img/2_83.ebf6e741.png";